module.exports = "/images/trail-6.jpg";